export type Constants = {
  ads_reactions: number;
  ads_reveal_with_rewarded: boolean;
  ads_show_bottom_banner: boolean;
  ads_show_messages_banner: boolean;
  allow_screenshots?: boolean;
  ambassador_video_1_url: string;
  ambassador_video_2_url: string;
  ambassador_video_3_url: string;
  audio_prompt_min_duration?: number;
  beginner_langs: string[];
  boost_timeout: number;
  expiration_critical_duration?: number;
  expiration_duration?: number;
  facebook_url?: string;
  force_bp?: boolean;
  free_smashes_interval_millis: number;
  gifs_provider?: string;
  gold_popular_index?: number;
  ignore_offer?: boolean;
  instagram_url?: string;
  linkedin_url?: string;
  matches_page_size: number;
  no_swipes: boolean;
  page_size: number;
  reddit_url?: string;
  subscription_bonus_boosts: number;
  subscription_bonus_super_smashes: number;
  telegram_url?: string;
  test?: true;
  tiktok_url?: string;
  youtube_url?: string;
};

export const defaultConstants: Constants = {
  ads_reactions: 4000,
  ads_reveal_with_rewarded: true,
  ads_show_bottom_banner: true,
  ads_show_messages_banner: false,
  ambassador_video_1_url: 'https://youtube.com/shorts/9uUxIBCC5Tw',
  ambassador_video_2_url: 'https://youtube.com/shorts/_WsdMXEIMi0',
  ambassador_video_3_url: 'https://youtube.com/shorts/zQO5ALBuorU',
  audio_prompt_min_duration: 2000,
  beginner_langs: [
    'de',
    'hi',
    'fi',
    'ru',
    'pt',
    'fr',
    'hu',
    'uk',
    'sk',
    'ga',
    'id',
    'sv',
    'ko',
    'el',
    'en',
    'eo',
    'it',
    'es',
    'zh',
    'cs',
    'ar',
    'ja',
    'az',
    'fa',
    'pl',
    'da',
    'he',
    'nl',
    'tr',
  ],
  boost_timeout: 86400000,
  expiration_critical_duration: 21600000,
  expiration_duration: 86400000,
  free_smashes_interval_millis: 43200000,
  matches_page_size: 5,
  no_swipes: false,
  page_size: 20,
  subscription_bonus_boosts: 1,
  subscription_bonus_super_smashes: 3,
};
